import styles from './index.module.css';

function ComponentTraceLoader(props) {
  let { type, rowSize } = props;
  let rowArray = new Array(rowSize || 3).fill(null);

  switch (type) {
    case 'LABEL_FILTER':
      return (
        <>
          {rowArray.map((value, index) => {
            return (
              <div
                key={`key_0${index}${value}`}
                className={`ltw-flex ltw-items-center ltw-pt-14px ltw-pb-10px ltw-border-b ltw-border-gray-1 ltw-cursor-pointer ${styles.filterLabelLoader}`}
              >
                <div
                  className={`ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item filter-label-loader-box1 ${styles.filterLabelLoaderBox1}`}
                >
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                <div
                  className={`ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item filter-label-loader-box2 ${styles.filterLabelLoaderBox2}`}
                >
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                {/* <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div> */}
                {/* <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
              <div className={`${styles.baseStyle}`}></div>
            </div> */}
              </div>
            );
          })}
        </>
      );
    case 'JOB_LIST':
      return (
        <>
          {rowArray.map((value, index) => {
            return (
              <div
                key={`key_0${index}${value}`}
                className="ltw-flex ltw-items-center ltw-pt-14px ltw-pb-10px ltw-border-b ltw-border-gray-1 ltw-cursor-pointer ltw-min-h-70px ltw-pl-15px"
              >
                <div className="ltw-flex ltw-items-center ltw-justify-between ltw-gap-16px ltw-flex-large-item">
                  <div className="ltw-flex ltw-items-center ltw-gap-16px">
                    <div
                      className={`${styles.baseStyle} ltw-w-18px ltw-h-18px ltw-rounded-full`}
                    ></div>
                    <div className={`${styles.baseStyle}`}></div>
                  </div>
                </div>
                <div
                  className={`ltw-flex ltw-items-center ltw-gap-5px ${styles.taskCol}`}
                >
                  <div
                    className={`${styles.baseStyle} ${styles.taskColWidth}`}
                  ></div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                {/* <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div> */}
                {/* <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
              <div className={`${styles.baseStyle}`}></div>
            </div> */}
              </div>
            );
          })}
        </>
      );
    case 'HOME_PAGE':
      return (
        <div className="ltw-ml-10px">
          <div className="ltw-flex ltw-items-center ltw-justify-between ltw-pt-20px ltw-pb-20px ltw-border-b ltw-border-gray-1">
            <div className="ltw-flex ltw-items-center ltw-justify-between">
              <div className="ltw-flex ltw-items-center">
                <div className={`${styles.baseStyle}`}></div>
              </div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-justify-between ltw-gap-10px">
              <div className="ltw-flex ltw-items-center ltw-justify-between">
                <div className="ltw-flex ltw-items-center">
                  <div className={`${styles.baseStyle} ltw-w-70px`}></div>
                </div>
              </div>
              <div className="ltw-flex ltw-items-center">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
              </div>
              <div className="ltw-flex ltw-items-center">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
              </div>
              <div className="ltw-flex ltw-items-center">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
              </div>
            </div>
          </div>
          <div className="ltw-flex ltw-items-center ltw-pt-20px ltw-pb-20px ltw-border-b ltw-border-gray-1">
            <div className="ltw-flex ltw-items-center ltw-justify-between ltw-gap-16px ltw-flex-large-item">
              <div className="ltw-flex ltw-items-center ltw-gap-16px">
                <div className={`${styles.baseStyle}`}></div>
              </div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
              <div className={`${styles.baseStyle}`}></div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
              <div className={`${styles.baseStyle}`}></div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
              <div className={`${styles.baseStyle}`}></div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
              <div className={`${styles.baseStyle}`}></div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
              <div className={`${styles.baseStyle}`}></div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
              <div className={`${styles.baseStyle}`}></div>
            </div>
            {/* <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
              <div className={`${styles.baseStyle}`}></div>
            </div> */}
            {/* <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
              <div className={`${styles.baseStyle}`}></div>
            </div> */}
          </div>
          {rowArray.map((value, index) => {
            return (
              <div
                key={`key_${index}`}
                className="ltw-flex ltw-items-center ltw-pt-14px ltw-pb-10px ltw-border-b ltw-border-gray-1 ltw-cursor-pointer ltw-min-h-70px"
              >
                <div className="ltw-flex ltw-items-center ltw-justify-between ltw-gap-16px ltw-flex-large-item">
                  <div className="ltw-flex ltw-items-center ltw-gap-16px">
                    <div
                      className={`${styles.baseStyle} ltw-w-18px ltw-h-18px ltw-rounded-full`}
                    ></div>
                    <div className={`${styles.baseStyle}`}></div>
                  </div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div>
                {/* <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div> */}
                {/* <div className="ltw-flex ltw-items-center ltw-gap-5px ltw-flex-small-item">
                  <div className={`${styles.baseStyle}`}></div>
                </div> */}
              </div>
            );
          })}
          ;
        </div>
      );
    case 'ASSOCIATES_TESTS':
      return (
        <div className="ltw-flex ltw-gap-19px ltw-items-center ltw-p-12px">
          <div>
            <div className={`${styles.baseStyle}`}></div>
          </div>
          <div className="ltw-flex ltw-gap-10px ltw-overflow-auto ltw-whitespace-nowrap">
            {rowArray.map((val, ind) => {
              return (
                <div
                  key={`inner${ind}`}
                  className="ltw-p-8px ltw-flex ltw-gap-10px ltw-items-center"
                >
                  <div className={`${styles.baseStyle}`}></div>
                </div>
              );
            })}
          </div>
        </div>
      );
    case 'ASSOCIATED_TEST_LIST':
      return rowArray.map((value, index) => {
        return (
          <div
            key={`key_${index}`}
            className="ltw-flex ltw-items-center ltw-px-10px ltw-py-7px ltw-border-b ltw-border-gray-1 ltw-cursor-pointer ltw-min-h-15px ltw-justify-between"
          >
            <div className="ltw-flex ltw-items-center ltw-justify-between ltw-gap-16px ltw-flex-large-item">
              <div className="ltw-flex ltw-items-center ltw-gap-16px">
                <div
                  className={`${styles.baseStyle} ltw-w-15px ltw-h-15px ltw-rounded-full`}
                ></div>
                <div className={`${styles.baseStyle}`}></div>
              </div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-justify-between ltw-gap-16px">
              <div className="ltw-flex ltw-items-center ltw-gap-16px">
                <div
                  className={`${styles.baseStyle} ltw-w-12px ltw-h-12px ltw-rounded-full`}
                ></div>
              </div>
            </div>
          </div>
        );
      });
    case 'STAGE_LIST':
      return (
        <div className="ltw-overflow-auto ltw-h-full">
          {rowArray.map((value, index) => {
            return (
              <div
                className="ltw-p-8px ltw-bg-group-list-bg-color"
                key={`inner${index}`}
              >
                <div className="ltw-flex ltw-items-start ltw-gap-16px ltw-flex-large-item ltw-my-5px ltw-flex ltw-justify-between">
                  <div className="ltw-flex ltw-gap-15px">
                    <div className={`${styles.baseStyle} ltw-w-20px`}></div>
                    <div className={`${styles.baseStyle} ltw-w-20px`}></div>
                    <div className={`${styles.baseStyle} ltw-w-336px`}></div>
                  </div>
                  <div className={`${styles.baseStyle} ltw-w-20px`}></div>
                </div>
              </div>
            );
          })}
        </div>
      );
    case 'JOB_DETAIL':
      return (
        <div>
          <div className="ltw-flex ltw-items-center ltw-justify-between ltw-pt-20px ltw-pb-20px ltw-border-b ltw-border-gray-1 ltw-min-h-70px">
            <div className="ltw-flex ltw-items-center ltw-justify-between">
              <div className="ltw-flex ltw-items-center">
                <div className={`${styles.baseStyle}`}></div>
              </div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-justify-between ltw-gap-10px">
              <div className="ltw-flex ltw-items-center ltw-justify-between">
                <div className="ltw-flex ltw-items-center">
                  <div className={`${styles.baseStyle} ltw-w-70px`}></div>
                </div>
              </div>
              <div className="ltw-flex ltw-items-center">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
              </div>
              <div className="ltw-flex ltw-items-center">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
              </div>
              <div className="ltw-flex ltw-items-center">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
              </div>
            </div>
          </div>
          <div className="ltw-flex ltw-justify-between ltw-items-center ltw-border-b ltw-border-gray-1">
            <div className="ltw-flex">
              <div className="ltw-flex ltw-flex-col ltw-gap-12px ltw-px-14px ltw-py-19px ltw-border-r ltw-border-gray-1">
                <div className={`${styles.baseStyle} ltw-w-45px`}></div>
                <div className={`${styles.baseStyle} ltw-w-20px`}></div>
              </div>
              <div className="ltw-flex ltw-flex-col ltw-gap-12px ltw-px-14px ltw-py-19px ltw-border-r ltw-border-gray-1">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
                <div className={`${styles.baseStyle} ltw-w-45px`}></div>
              </div>
              <div className="ltw-flex ltw-flex-col ltw-gap-12px ltw-px-14px ltw-py-19px ltw-border-r ltw-border-gray-1">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
                <div className={`${styles.baseStyle} ltw-w-30px`}></div>
              </div>
              <div className="ltw-flex ltw-flex-col ltw-gap-12px ltw-px-14px ltw-py-19px ltw-border-r ltw-border-gray-1">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
                <div className={`${styles.baseStyle} ltw-w-30px`}></div>
              </div>
              <div className="ltw-flex ltw-flex-col ltw-gap-12px ltw-px-14px ltw-py-19px ltw-border-r ltw-border-gray-1">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
                <div className={`${styles.baseStyle} ltw-w-30px`}></div>
              </div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-gap-10px">
              <div className="ltw-flex ltw-items-center ltw-gap-5px">
                <div className={`${styles.baseStyle}`}></div>
              </div>
              <div className="ltw-flex ltw-items-center ltw-gap-5px">
                <div className={`${styles.baseStyle}`}></div>
              </div>
            </div>
          </div>
          <div className="ltw-flex ltw-h-screen">
            <div className="ltw-w-336px ltw-border-r ltw-border-gray-1">
              <div className="ltw-flex ltw-justify-between ltw-items-center  ltw-p-15px ltw-border-b ltw-border-gray-1">
                <div className={`${styles.baseStyle} ltw-w-45px`}></div>
                <div className={`${styles.baseStyle} ltw-w-15px`}></div>
              </div>
              <div className="ltw-overflow-auto ltw-h-full">
                {rowArray.map((value, index) => {
                  return (
                    <div
                      className="ltw-p-12px ltw-bg-group-list-bg-color ltw-border-b ltw-border-gray-1 ltw-cursor-pointer"
                      key={`inner${index}`}
                    >
                      <div className="ltw-flex ltw-items-start ltw-gap-16px ltw-flex-large-item ltw-my-5px">
                        <div>
                          <div
                            className={`${styles.baseStyle} ltw-w-18px ltw-h-18px ltw-rounded-full`}
                          ></div>
                        </div>
                        <div>
                          <div
                            className={`${styles.baseStyle} ltw-w-30px`}
                          ></div>
                          <div className="ltw-flex ltw-items-start ltw-mt-10px ltw-items-center">
                            <div className={`${styles.baseStyle}`}></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="ltw-flex-large-column-item ltw-border-r ltw-border-gray-1 ltw-overflow-auto  ltw-h-full">
              <div className="ltw-flex ltw-justify-between ltw-items-center  ltw-p-15px ltw-border-b ltw-border-gray-1">
                <div className="ltw-flex ltw-gap-20px">
                  <div className={`${styles.baseStyle} ltw-w-60px`}></div>
                  <div className={`${styles.baseStyle} ltw-w-60px`}></div>
                  <div className={`${styles.baseStyle} ltw-w-60px`}></div>
                  <div className={`${styles.baseStyle} ltw-w-60px`}></div>
                </div>
                <div className={`${styles.baseStyle}`}></div>
              </div>
              {/* <div className="ltw-overflow-auto ltw-h-full">
                {rowArray.map((value, index) => {
                  return (
                    <div className="ltw-p-8px ltw-bg-group-list-bg-color">
                      <div className="ltw-flex ltw-items-start ltw-gap-16px ltw-flex-large-item ltw-my-5px ltw-flex ltw-justify-between">
                        <div className="ltw-flex ltw-gap-15px">
                          <div
                            className={`${styles.baseStyle} ltw-w-20px`}
                          ></div>
                          <div
                            className={`${styles.baseStyle} ltw-w-20px`}
                          ></div>
                          <div
                            className={`${styles.baseStyle} ltw-w-300px`}
                          ></div>
                        </div>
                        <div className={`${styles.baseStyle} ltw-w-20px`}></div>
                      </div>
                    </div>
                  );
                })}
              </div> */}
            </div>
          </div>
        </div>
      );
    case 'concurrency':
      return (
        <div className="ltw-flex ltw-items-center ltw-justify-between ltw-gap-10px">
          <div className="ltw-flex ltw-items-center ltw-justify-between">
            <div className="ltw-flex ltw-items-center">
              <div className={`${styles.baseStyle} ltw-w-70px`}></div>
            </div>
          </div>
          <div className="ltw-flex ltw-items-center">
            <div className={`${styles.baseStyle} ltw-w-70px`}></div>
          </div>
          <div className="ltw-flex ltw-items-center">
            <div className={`${styles.baseStyle} ltw-w-70px`}></div>
          </div>
          <div className="ltw-flex ltw-items-center">
            <div className={`${styles.baseStyle} ltw-w-70px`}></div>
          </div>
        </div>
      );
    case 'ASSOCIATES_MORE_VR':
      return (
        <div className="ltw-flex ltw-flex-col ltw-items-center ltw-justify-between ltw-gap-20px ltw-mt-15px">
          {[1, 2, 3].map((_, index) => {
            return (
              <div className="ltw-flex ltw-items-center" key={`inner0${index}`}>
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
              </div>
            );
          })}
        </div>
      );
    case 'screenshot-block':
      return (
        <div>
          {[1, 2, 3, 4, 5].map((_, index) => {
            return (
              <div
                className="ltw-flex ltw-items-center ltw-justify-between ltw-mb-20px"
                key={`inner02${index}`}
              >
                <div
                  className={`${styles.baseStyle} ltw-h-180px ltw-w-full`}
                ></div>
              </div>
            );
          })}
        </div>
      );
    case 'screenshot-block-large':
      return (
        <div>
          <div className="ltw-flex ltw-items-center ltw-justify-between ltw-mb-20px">
            <div className={`${styles.baseStyle} ltw-h-380px ltw-w-full`}></div>
          </div>
        </div>
      );
    case 'vr-resolution-bar':
      return (
        <div className="ltw-flex ltw-items-center ltw-justify-between ltw-pt-10px ltw-pb-20px ltw-border-b ltw-border-gray-1 ltw-my-25px ltw-mx-20px">
          <div className="ltw-flex ltw-items-center ltw-justify-between ltw-gap-10px">
            <div className="ltw-flex ltw-items-center">
              <div className={`${styles.baseStyle}`}></div>
            </div>
            <div className="ltw-flex ltw-items-center ltw-justify-between">
              <div className="ltw-flex ltw-items-center">
                <div className={`${styles.baseStyle} ltw-w-70px`}></div>
              </div>
            </div>
            <div className="ltw-flex ltw-items-center">
              <div className={`${styles.baseStyle} ltw-w-70px`}></div>
            </div>
          </div>
          <div className="ltw-flex ltw-items-center ltw-justify-between ltw-gap-10px">
            <div className="ltw-flex ltw-items-center">
              <div className={`${styles.baseStyle} ltw-w-70px`}></div>
            </div>
            <div className="ltw-flex ltw-items-center">
              <div className={`${styles.baseStyle} ltw-w-70px`}></div>
            </div>
          </div>
        </div>
      );
    case 'secret':
      return (
        <div>
          {[1, 2, 3, 4, 5].map((_, index) => {
            return (
              <div
                className="ltw-flex ltw-items-center ltw-justify-between ltw-h-40px"
                key={`inner04${index}`}
              >
                <div className="ltw-flex ltw-items-center ltw-justify-between">
                  <div className="ltw-flex ltw-items-center">
                    <div className={`${styles.baseStyle} ltw-w-70px`}></div>
                  </div>
                </div>
                <div className="ltw-flex ltw-items-center">
                  <div className={`${styles.baseStyle} ltw-w-70px`}></div>
                </div>
              </div>
            );
          })}
        </div>
      );
    default:
      return <div />;
  }
}

export default ComponentTraceLoader;
